export const brands = ({ brands }) => brands;
export const models = ({ models }) => models;
